import { StockGroup, StockGroupCreate, StockGroupEdit, StockItem, StockItemCreate, StockItemEdit, Barcode } from "../Components/index.js";

export default [
    {
        path: "/bn-store/inventory/group",
        component: StockGroup,
        name: "product.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bn-store/inventory/group/create",
        component: StockGroupCreate,
        name: "product.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bn-store/inventory/group/:id/edit",
        component: StockGroupEdit,
        name: "product.group.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/bn-store/inventory/item",
        component: StockItem,
        name: "product.item",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bn-store/inventory/barcode/show",
        component: Barcode,
        name: "product.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bn-store/inventory/item/create",
        component: StockItemCreate,
        name: "product.item.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bn-store/inventory/item/:id/edit",
        component: StockItemEdit,
        name: "product.item.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
